export const basicCover = () => ({
  type: 'page',
  meta: {
    id: 'doc:home',
    title: '',
    createDate: 1706086837052,
    tags: [],
  },
  blocks: {
    type: 'block',
    id: 'QiBH29dycZ',
    flavour: 'affine:page',
    version: 2,
    props: {
      title: {
        '$blocksuite:internal:text$': true,
        delta: [],
      },
    },
    children: [
      {
        type: 'block',
        id: 'WZ9zUizVrs',
        flavour: 'affine:surface',
        version: 5,
        props: {
          elements: {
            DcoFASHQKI: {
              index: 'a1',
              seed: 1391437441,
              xywh: '[-83.54346701558063,-50.225603646128235,1600.17596435546875,179]',
              rotate: 0,
              text: {
                'affine:surface:text': true,
                delta: [
                  {
                    insert: 'section1.title',
                  },
                ],
              },
              color: '--affine-palette-line-black',
              fontSize: 128,
              fontFamily: 'blocksuite:surface:Poppins',
              fontWeight: '400',
              fontStyle: 'normal',
              textAlign: 'left',
              type: 'text',
              id: 'DcoFASHQKI',
              hasMaxWidth: false,
            },
          },
        },
        children: [
          {
            type: 'block',
            id: 'Rb6xTvGyzU',
            flavour: 'affine:image',
            version: 1,
            props: {
              caption: 'background',
              sourceId: 'xeeMw2R2FtjRo2Q0H14rsCpImSR9-z54W_PDZUsFvJ8=',
              width: 1920,
              height: 1080,
              index: 'a0',
              xywh: '[-300.7451171875,-355.744140625,1920,1080]',
              rotate: 0,
              size: 938620,
            },
            children: [],
          },
          {
            type: 'block',
            id: 'Pa1ZO7Udi-',
            flavour: 'affine:frame',
            version: 1,
            props: {
              title: {
                '$blocksuite:internal:text$': true,
                delta: [
                  {
                    insert: 'title',
                  },
                ],
              },
              background: '--affine-palette-transparent',
              xywh: '[-340.7451171875,-395.744140625,2000,1160]',
              index: 'a0',
            },
            children: [],
          },
        ],
      },
    ],
  },
});
